import * as THREE from 'three';
import { Starfield } from './starfield.js';
import { Nebula } from './nebula.js';
import { ParticleSystem } from './particles.js';

export class CosmicScene {
  constructor(canvas) {
    this.canvas = canvas;
    this.renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      alpha: true,
    });
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.setClearColor(0x0a0a0f, 1);

    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(60, 1, 0.1, 500);
    this.camera.position.z = 50;

    // Create visual layers
    this.starfield = new Starfield(this.scene);
    this.nebula = new Nebula(this.scene);
    this.particles = new ParticleSystem(this.scene);

    this._clock = new THREE.Clock();
    this._lastTime = 0;

    this.resize();
    window.addEventListener('resize', () => this.resize());
  }

  resize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    this.renderer.setSize(w, h);
    this.camera.aspect = w / h;
    this.camera.updateProjectionMatrix();
  }

  emitParticles(note) {
    this.particles.emit(note);
  }

  update(waveformData, fftData) {
    const time = this._clock.getElapsedTime();
    const dt = time - this._lastTime;
    this._lastTime = time;

    // Extract frequency bands from FFT
    let bass = 0, mid = 0, high = 0;
    if (fftData && fftData.length > 0) {
      const len = fftData.length;
      const bassEnd = Math.floor(len * 0.1);
      const midEnd = Math.floor(len * 0.4);

      for (let i = 0; i < bassEnd; i++) {
        bass += (fftData[i] + 100) / 100;
      }
      bass = Math.max(0, bass / bassEnd);

      for (let i = bassEnd; i < midEnd; i++) {
        mid += (fftData[i] + 100) / 100;
      }
      mid = Math.max(0, mid / (midEnd - bassEnd));

      for (let i = midEnd; i < len; i++) {
        high += (fftData[i] + 100) / 100;
      }
      high = Math.max(0, high / (len - midEnd));
    }

    // Update visual layers
    this.starfield.update(time, high);
    this.nebula.update(time, bass, mid, high);
    this.particles.update(dt);

    this.renderer.render(this.scene, this.camera);
  }
}
